module.exports = __webpack_public_path__ + "static/media/DMSans-Regular.62874e40.woff2";